import React from 'react';
import { string, shape, bool, func } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import { Loader } from '@tesla/design-system-react';
import { SiteFooter } from '@tesla/tw-react';
import Content from './pages';
import Selectors from './common/redux/selectors';
import * as actions from './common/redux/actions';

import '@tesla/design-system/dist/index.css';
import '@tesla/payment-react/styles.css';
import '@tesla/tw-react/dist/index.css';

import './css/reset.css';
import styles from './App.module.css';

const propTypes = {
  store: shape({}).isRequired,
  initialData: shape({}).isRequired,
  baseRoute: string.isRequired,
  showLoader: bool,
  getTranslations: func.isRequired,
  commonTranslations: shape({}).isRequired,
};

const defaultProps = {
  showLoader: false,
};

const App = ({
  store,
  baseRoute,
  showLoader,
  initialData,
  commonTranslations,
  getTranslations,
}) => {
  const { locale } = initialData;
  if (Object.keys(commonTranslations).length === 0) {
    getTranslations(locale);
  }

  return (
    <Provider store={store}>
      <div className={styles.AppWrapper}>
        <BrowserRouter basename={baseRoute}>
          <Loader fullscreen show={showLoader} />
          <Content />
        </BrowserRouter>
      </div>
      <SiteFooter locale={locale} />
    </Provider>
  );
};
App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default connect(
  Selectors,
  actions
)(App);
